module.exports = __webpack_public_path__ + "assets/images/project/constituencies/nee-soon-grc.jpg?v=1f807bb3";